// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2521":"21912276e5c0be18a062","2888":"6531fe8c1aace9fa6309","5978":"21912276e5c0be18a062"}[chunkId] + ".css";
};